package org.matthewo.styles

import csstype.PropertiesBuilder
import org.matthewo.symbolprocessor.Period
import web.cssom.Color
import web.cssom.integer

const val FONT = "\"JetBrains Mono\", sans-serif"
val FONT_COLOR = Color("#ffffff")
val TITLE_FONT_COLOR = Color("#a531e1")

val BACKGROUND_COLOR = Color("#161616")

data class ColorGroup(
    val tableHead: Color,
    val tableBody: Color,
    val chart: Color,
)

val INFO_COLOR = ColorGroup(Color("#252525"), BACKGROUND_COLOR, BACKGROUND_COLOR)
val TOTAL_COLOR = ColorGroup(Color("#404000"), Color("#404020"), Color("#bfc036"))
val AUTO_COLOR = ColorGroup(Color("#06ac00"), Color("#204020"), Color("#82ca9d"))
val TELEOP_COLOR = ColorGroup(Color("#0000ac"), Color("#202040"), Color("#7675c5"))
val ENDGAME_COLOR = ColorGroup(Color("#ac0000"), Color("#402020"), Color("#cf4b4d"))

fun Period.color() = when (this) {
    Period.ALL -> INFO_COLOR
    Period.AUTO -> AUTO_COLOR
    Period.TELEOP -> TELEOP_COLOR
    Period.ENDGAME -> ENDGAME_COLOR
}

val TABLE_HEAD_RED = Color("#c41435")
val TABLE_HEAD_BLUE = Color("#141ac2")
val TABLE_BODY_RED = Color("#53232b")
val TABLE_BODY_BLUE = Color("#232554")

enum class AllianceColor(val backgroundColor: Color, val highlightColor: Color) {
    RED(TABLE_BODY_RED, TABLE_HEAD_RED),
    BLUE(TABLE_BODY_BLUE, TABLE_HEAD_BLUE),
}

var PropertiesBuilder.gridColumns: IntRange?
    get() {
        val start = gridColumnStart.toString().toIntOrNull()
        val end = gridColumnEnd.toString().toIntOrNull()
        return if (null != start && null != end) start..end else null
    }
    set(value) {
        if (null != value) {
            gridColumnStart = integer(value.first)
            gridColumnEnd = integer(value.last)
        }
    }

var PropertiesBuilder.gridRows: IntRange?
    get() {
        val start = gridRowStart.toString().toIntOrNull()
        val end = gridRowEnd.toString().toIntOrNull()
        return if (null != start && null != end) start..end else null
    }
    set(value) {
        if (null != value) {
            gridRowStart = integer(value.first)
            gridRowEnd = integer(value.last)
        }
    }
